export default "__VITE_PUBLIC_ASSET__d21c1e6d__"